import api from '@/modules/api'
import * as Helper from '@/modules/helper/index'
import CountdownTime from '@/modules/helper/countDownTime'
import moment from 'moment'

export default {
  state: {
    invitedUsers: [],
    userLevels: [],
    userOfferDetails: {
      IsOfferPeriod: false,
      OfferCountdowntimer: null,
      OfferLeftminutes: 0,
      OfferLeftseconds: 0,
      InOrderProcess: false,
      EndOffer: false
    },
    subscriptionOffer: [],
    isSubscriptionOffer: false,
    subscriptionOfferPrice: [],
    subscriptionPeriodOfferPrice: []
  },
  getters: {
    invitedUsers (state) {
      return state.invitedUsers
    },
    userOfferDetails: state => state.userOfferDetails,
    subscriptionOffer: state => state.subscriptionOffer,
    isSubscriptionOffer: state => state.isSubscriptionOffer,
    subscriptionOfferPrice: state => state.subscriptionOfferPrice,
    subscriptionPeriodOfferPrice: state => state.subscriptionPeriodOfferPrice
  },
  mutations: {
    setInvitedUsers (state, users) {
      state.invitedUsers = users
    },
    updateOfferDetails (state, payload) {
      Object.assign(state.userOfferDetails, payload)
    },
    setsubscriptionOffer (state, payload) {
      state.subscriptionOffer = payload
    },
    setisSubscriptionOffer (state, payload) {
      state.isSubscriptionOffer = payload
    },
    setsubscriptionOfferPrice (state, payload) {
      state.subscriptionOfferPrice = payload
    },
    setsubscriptionPeriodOfferPrice (state, payload) {
      state.subscriptionPeriodOfferPrice = payload
    }
  },
  actions: {
    populateInvitedUsers: async ({ rootGetters, commit }) => {
      let response = await api.UserManagment.GetInvitedUsers(rootGetters.activeSubscriptionId)
      if (Helper.IsValid(response, true)) {
        for (var user of response) {
          user.RegistrationDate = moment.utc(user.RegistrationDate).format(user.DateTimeFormat.toUpperCase().split(' ')[0])
        }
        commit('setInvitedUsers', response)
      } else {
        commit('setInvitedUsers', [])
      }
    },
    inviteNewUser: async ({ dispatch, rootGetters }, payload) => {
      let response = await api.UserManagment.InviteUser(payload)
      if (Helper.IsValid(response, true)) {
        dispatch('populateInvitedUsers')
      }
    },
    unInviteUser: async ({ dispatch }, payload) => {
      let response = await api.UserManagment.UnInviteUser(payload)
      if (Helper.IsValid(response, true)) {
        dispatch('populateInvitedUsers')
      }
    },
    async setOfferPeriod ({ commit, rootGetters, state }) {
      let serverDateTime = await api.system.currentTime()
      let currentDateTime = moment(serverDateTime)
      let registrationDateTime = moment(rootGetters.user.RegistrationDate).add(1, 'hour')
      if (rootGetters.userOfferDetails.OfferCountdowntimer && rootGetters.userOfferDetails.OfferCountdowntimer.abort) {
        rootGetters.userOfferDetails.OfferCountdowntimer.abort()
      }
      if (currentDateTime < registrationDateTime) {
        state.userOfferDetails.OfferCountdowntimer = CountdownTime.timer(currentDateTime, registrationDateTime, function (timeLeft) {
          commit('updateOfferDetails', {
            OfferLeftminutes: timeLeft.minutes,
            OfferLeftseconds: timeLeft.seconds,
            IsOfferPeriod: true
          })
        }, function () {
          commit('updateOfferDetails', {
            OfferLeftminutes: 0,
            OfferLeftseconds: 0,
            IsOfferPeriod: false
          })
        }
        )
      } else {
        commit('updateOfferDetails', {
          OfferLeftminutes: 0,
          OfferLeftseconds: 0,
          IsOfferPeriod: false
        })
      }

      let currentTimeStamp = moment().unix()
      let offerResponse = await api.Order.getSubscriptionOffer(currentTimeStamp, rootGetters.user.Id)
      commit('setsubscriptionOffer', offerResponse)
      let counterOffer = offerResponse.length > 0 ? offerResponse.find(product => product.Id === -1000) : null
      if (state.userOfferDetails.IsOfferPeriod && counterOffer != null) {
        let subscriptionCounterOfferOfferPrice = await api.Order.getSystemTableBillingSpecialOffersPricing(-1000, rootGetters.user.Language, rootGetters.user.Currency)
        commit('setsubscriptionOfferPrice', subscriptionCounterOfferOfferPrice)
      }
      let normaloffer = offerResponse.length > 0 ? offerResponse.find(product => product.Id > 0) : null
      if (normaloffer != null && normaloffer.Id > 0) {
        commit('setisSubscriptionOffer', true)
        let subscriptionOfferPrice = await api.Order.getSystemTableBillingSpecialOffersPricing(normaloffer.Id, rootGetters.user.Language, rootGetters.user.Currency)
        commit('setsubscriptionPeriodOfferPrice', subscriptionOfferPrice)
      }
      // let subscriptionOfferPrice = []
      // if (offerResponse != null && offerResponse.length > 0) {
      //   offerResponse.forEach(async (data) => {
      //     let subscriptionOfferPriceTemp = await api.Order.getSystemTableBillingSpecialOffersPricing(data.Id, rootGetters.user.Language, rootGetters.user.Currency)
      //     subscriptionOfferPrice.push(subscriptionOfferPriceTemp)
      //   })
      //   commit('setsubscriptionOfferPrice', subscriptionOfferPrice)
      // }
    },
    setOfferDetailsIsInOderPage: async ({ rootGetters, commit, state }, payload) => {
      commit('updateOfferDetails', {
        ...state.userOfferDetails,
        InOrderProcess: payload
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/userManagement.js